export const isBundleLandingSchoolDetailsRequired = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    const searchParams = new URLSearchParams(window.location.search);

    let itemIdsParam = searchParams.get("item_ids");
    let bundleLandingParam = searchParams.get("bundleLanding");

    if (!itemIdsParam) {
      itemIdsParam = sessionStorage.getItem("item_ids") || "";
    }

    if (!bundleLandingParam) {
      bundleLandingParam = sessionStorage.getItem("bundleLanding") || "";
    }

    if (!bundleLandingParam) {
      return false;
    }

    const isBundleLandingTrue =
      bundleLandingParam.toLowerCase() === "true" || bundleLandingParam === "1";

    if (!isBundleLandingTrue) {
      return false;
    }

    const parsedItemIds = (itemIdsParam || "")
      .split(/[,-]/)
      .map((id) => parseInt(id.trim(), 10))
      .filter((id) => !Number.isNaN(id));

    return parsedItemIds.some((id) => id === 11 || id === 12);
  } catch (error) {
    console.error("Error determining bundle landing eligibility:", error);
    return false;
  }
};
